export default __webpack_public_path__ + "static/media/noRole.19463c4f.png";